import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@mui/material';
import UsersTable from './UsersTable/UsersTable';
import EmailDialogs from './EmailDialogs/EmailDialogs';
import useStyles from './UsersDashboard.styles';

const UsersDashboard: FunctionComponent = () => {
  const testid = 'users-table';
  const classes = useStyles();

  return (
    <Grid container spacing={4}>
      <Grid size={{xs:12}}>
        <Typography
          variant="h1"
          className={classes.title}
          data-testid={`${testid}__title`}
        >
          HealthySteps ROI Calculator Users
        </Typography>
      </Grid>
      <Grid size={{xs:12}}>
        <UsersTable />
      </Grid>
      <EmailDialogs />
    </Grid>
  );
};

export default UsersDashboard;
